import { IApplicationState } from '../../types/redux';

export function selectNewbuildingNewPromoPinsEnabled(state: IApplicationState): boolean {
  return state.config.newbuildingNewPromoPinsEnabled;
}
